import { render, staticRenderFns } from "./p-desktop.vue?vue&type=template&id=5ac54a61&"
import script from "./p-desktop.vue?vue&type=script&lang=js&"
export * from "./p-desktop.vue?vue&type=script&lang=js&"
import style0 from "./p-desktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports